module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('van-popup', {
    attrs: {
      "position": "bottom",
      "lazy-render": false
    },
    model: {
      value: (_vm.popupShow),
      callback: function($$v) {
        _vm.popupShow = $$v
      },
      expression: "popupShow"
    }
  }, [_c('div', {
    staticClass: "page bg-fff page-flex"
  }, [_c('titleBar', {
    attrs: {
      "leftEle": _vm.leftEle,
      "rightText": _vm.rightText
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "map allmap",
    attrs: {
      "id": "allmap"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "search-input-box"
  }, [_c('div', {
    staticClass: "search-input"
  }, [_c('div', {
    staticClass: "alifont icon-xpsousuo"
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.keyword),
      expression: "keyword"
    }],
    attrs: {
      "type": "search",
      "placeholder": "请输入要搜索地址的地址"
    },
    domProps: {
      "value": (_vm.keyword)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 13) { return null; }
        return _vm.autoInput.apply(null, arguments)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.keyword = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "flex1 address-list pd-025"
  }, _vm._l((_vm.searchList), function(item, $index) {
    return _c('div', {
      key: $index,
      staticClass: "flex-center pd-250 bd-bot",
      on: {
        "click": function($event) {
          return _vm.chooseAddress(item)
        }
      }
    }, [_c('div', {
      staticClass: "flex1 ofh"
    }, [_c('div', {
      staticClass: "fs-32 color-333"
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('div', {
      staticClass: "fs-24 color-999 text-el mt-10"
    }, [_vm._v(_vm._s(item.address))])]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.locationId == item.id),
        expression: "locationId == item.id"
      }],
      staticClass: "alifont icon-xuanzhong1 color-main ml-15",
      staticStyle: {
        "font-size": ".48rem"
      }
    })])
  }), 0)], 1), _vm._v(" "), _c('van-popup', {
    style: ({
      background: 'none',
      overflow: 'hidden'
    }),
    model: {
      value: (_vm.loading),
      callback: function($$v) {
        _vm.loading = $$v
      },
      expression: "loading"
    }
  }, [_c('van-loading', {
    attrs: {
      "size": "40px",
      "color": "#fff",
      "vertical": ""
    }
  }, [_c('span', {
    staticClass: "color-fff"
  }, [_vm._v("搜索中...")])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-040dabc6","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/shop/chooseAddress.vue
// module id = vZX2
// module chunks = 51